import GuidedPracticeTutorialModal from './GuidedPracticeTutorialModal';

export default GuidedPracticeTutorialModal;
